module.exports = __webpack_public_path__ + "static/media/movie_thumb.a0b90428.png";